module.exports = __webpack_public_path__ + "img/01-thumb.f356fc41.png";